import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-item-image',
  templateUrl: './item-image.component.html',
  styleUrls: ['./item-image.component.scss'],
})
export class ItemImageComponent {
  @Input() imageUrl: string;
  @Input() size:
    | 'small'
    | 'compact'
    | 'medium'
    | 'large'
    | 'large-portrait'
    | 'extra-large' = 'medium';
  @Input() altText: string = 'Item image';
  @Input() useBackgroundImage: boolean = false; // Support for background-image style
}
